import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";
import { scrollToId } from "../lib/scroll";

const links = [
  { label: "Il Metodo", id: "metodo-sintesi" },
  { label: "Aree", id: "approccio" },
  { label: "Sport", id: "sport" },
  { label: "Percorso", id: "metodo" },
  { label: "Formazione", id: "formazione" },
  { label: "App", id: "app", soon: true },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (l) => {
    if (l.soon) {
      toast("FG Clone Coach — disponibile a breve", {
        description: "L'app in abbonamento è in arrivo. Resta sintonizzato.",
      });
      return;
    }
    scrollToId(l.id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-black/50 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => scrollToId("hero")}
          className="text-left group"
          data-testid="nav-logo"
        >
          <span className="block font-serif text-lg md:text-xl tracking-tight text-foreground leading-none">
            Metodo Sintesi
          </span>
          <span className="block text-[10px] tracking-[0.3em] text-primary mt-1">
            DI FRANCESCO GALLI
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => handleClick(l)}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300 relative group"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
              {l.soon && (
                <sup className="ml-1 text-[8px] tracking-wider text-primary align-super">
                  soon
                </sup>
              )}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-primary group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </div>

        <button
          onClick={() => scrollToId("candidatura")}
          className="hidden md:inline-flex items-center rounded-full border border-primary/60 px-6 py-2.5 text-xs tracking-[0.15em] text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-400"
          data-testid="nav-cta"
        >
          CANDIDATI
        </button>

        <button
          className="md:hidden text-foreground text-sm tracking-widest"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? "CHIUDI" : "MENU"}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/80 backdrop-blur-xl border-b border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button
                  key={l.id}
                  onClick={() => {
                    handleClick(l);
                    if (!l.soon) setOpen(false);
                  }}
                  className="text-left text-base text-foreground"
                  data-testid={`nav-mobile-link-${l.id}`}
                >
                  {l.label}
                  {l.soon && (
                    <span className="ml-2 text-[10px] tracking-wider text-primary">
                      soon available
                    </span>
                  )}
                </button>
              ))}
              <button
                onClick={() => {
                  scrollToId("candidatura");
                  setOpen(false);
                }}
                className="mt-2 rounded-full bg-primary text-primary-foreground py-3 text-xs tracking-[0.15em]"
                data-testid="nav-mobile-cta"
              >
                CANDIDATI
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
